export { default } from './Splitio';
